import React from 'react'
import {
  styled,
  Checkbox as MuiCheckbox,
  FormControlLabel as MuiFormControlLabel,
} from '@material-ui/core'
import {useObjectivesState, useEditApplication} from 'lms/hooks'

const Content = styled('div')({})

const Heading = styled('h4')(({theme}) => ({
  margin: 0,
  marginTop: 12,
  marginBottom: 6,
  fontSize: 18,
  fontWeight: 500,
  color: theme.palette.text.secondary,
  borderBottom: `1px solid ${theme.palette.divider}`,
}))

const Grid = styled('div')({
  display: 'flex',
  flexDirection: 'column',
})

const FormControlLabel = styled(MuiFormControlLabel)({})

const nameSorter = (a, b) => a.name.localeCompare(b.name)

const Objectives = (props) => {
  const [application, updateApplication] = useEditApplication()
  const {data} = useObjectivesState()

  const appObjectives = application.objectives || []
  const isSelected = id => appObjectives.includes(id)

  const sortedObjectives = data.allIds.map(id => data.byId[id]).sort(nameSorter)

  const updateObjectives = (id, checked) => {
    const set = new Set(appObjectives)
    checked ? set.add(id) : set.delete(id)
    updateApplication({objectives: Array.from(set)})
  }

  const createCheck = id => (
    <MuiCheckbox
      checked={isSelected(id)}
      onChange={(e, checked) => updateObjectives(id, checked)}
    />
  )

  return (
    <Content {...props}>
      <Heading>Learning/Training Objectives</Heading>
      <Grid>
        {sortedObjectives.map((objective) => (
          <FormControlLabel
            key={objective.id}
            label={objective.name}
            control={createCheck(objective.id)}
          />
        ))}
      </Grid>
    </Content>
  )
}

export default Objectives
